import { ofType } from 'redux-observable';
import { switchMap, map } from 'rxjs/operators';
// import { ajax } from "rxjs/ajax";
import { ajax as UtilsAjax } from '../../Utils';
import { objectToUrl } from '../../Utils/ajax-utils';
import environment from '../../environments/environment';
import { APT_SAVE, CACHE, EXPORT_DATA, PAYER_SAVE, SEARCH_PATIENT } from './apt.types';
import {
  AppointmentSaveResponse,
  exportDataResponse,
  getCacheResponse,
  payerSaveResponse,
  searchPatientResponse,
} from './apt.actions';
import { Apis } from '../APIs';
const { baseUrl } = environment;
const { ClinicBaseUrl } = environment;
const AppointmentEpic = {};

/**
 * @fileOverview Manages the APIs w.r.t action in the redux
 * @author  Akhil Francis <akhil@trillium-technologies.com>
 * @example Name of the epic = (params) =>
 */

/**
 * Login
 * @description Calling the login API for a user to login
 * @param action$
 */
AppointmentEpic.searchPatientApi = (action$) =>
  action$.pipe(
    ofType(SEARCH_PATIENT),
    switchMap((action) =>
      UtilsAjax({
        url: `${ClinicBaseUrl}/${Apis.coder_searchPatientApi}?lastName=${action.payload.searchLastName}&dob=${action.payload.searchDob}&clinicId=${action.payload.clinicId}`,
        method: 'GET',
      }).pipe(
        map(
          (response) => searchPatientResponse(response)
          // takeUntil(action$.pipe(ofType(REQUEST_CANCEL))),
        )
      )
    )
  );

AppointmentEpic.cacheApi = (action$) =>
  action$.pipe(
    ofType(CACHE),
    switchMap((action) =>
      UtilsAjax({
        url: `${ClinicBaseUrl}/${Apis.coder_cacheApi}/${action.payload}`,
        method: 'GET',
      }).pipe(
        map(
          (response) => getCacheResponse(response)
          // takeUntil(action$.pipe(ofType(REQUEST_CANCEL))),
        )
      )
    )
  );
AppointmentEpic.AppointmentSaveApi = (action$) =>
  action$.pipe(
    ofType(APT_SAVE),
    switchMap((action) =>
      UtilsAjax({
        url: `${ClinicBaseUrl}/${Apis.coder_AppointmentSaveApi}/`,
        method: 'POST',
        body: JSON.stringify(action.payload),
      }).pipe(
        map(
          (response) => AppointmentSaveResponse(response)
          // takeUntil(action$.pipe(ofType(REQUEST_CANCEL))),
        )
      )
    )
  );
AppointmentEpic.payerSaveApi = (action$) =>
  action$.pipe(
    ofType(PAYER_SAVE),
    switchMap((action) =>
      UtilsAjax({
        url: `${ClinicBaseUrl}/${Apis.coder_payerSaveApi}/`,
        method: 'POST',
        body: JSON.stringify(action.payload),
      }).pipe(
        map(
          (response) => payerSaveResponse(response)
          // takeUntil(action$.pipe(ofType(REQUEST_CANCEL))),
        )
      )
    )
  );

  AppointmentEpic.exportData = (action$) =>
  action$.pipe(
    ofType(EXPORT_DATA),
    switchMap((action) =>
      UtilsAjax({
        url: objectToUrl(`${ClinicBaseUrl}/${Apis.coder_exportData}`, action.payload),
        method: 'GET',
        responseType:'blob'
      }).pipe(
        map(
          (response) => exportDataResponse(response),
          // takeUntil(action$.pipe(ofType(REQUEST_CANCEL)))
        )
      )
    )
  );

export default AppointmentEpic;
